








































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { gqlClient } from "@root/apollo/apollo-options";
import { mediaSignature } from "@root/graphql/Root.gql";
import axios from "axios";

@Component
export default class MultipleUploader extends Vue {
  private filePath: string = "";
  private loading: boolean = false;
  private ossOptions: any = {};
  private fileList = [];
  private picUrlList = [];

  @Prop({ type: String, default: "image/*,video/*" })
  accept!: string;

  @Prop({ type: String, default: "picture" })
  listType!: string;

  @Prop({ default: () => [] })
  dataList: any;

  @Prop({ default: null })
  maxSize: number;

  @Prop({ default: null })
  limit: null | number;

  @Prop({ default: false })
  disabled: boolean;

  @Watch("dataList")
  onDataListChange(val) {
    this.init();
  }

  async mounted() {
    this.init();
  }

  init() {
    this.fileList = this.dataList.map((item = "") => {
      let type = item.split(".");
      return { url: item, type: type[type.length - 1] };
    });
  }

  async getToken() {
    let res = await gqlClient.query({
      query: mediaSignature,
      variables: { tenantCode: "23r" }
    });
    this.ossOptions = res.data.mediaSignature;
  }

  async selectFile(e) {
    const $input: any = e.target;
    const file = $input.files[0];

    if (!file) return;
    const size = file.size / 1024;
    if (this.maxSize) {
      if (size > this.maxSize) {
        this.$message.error(`File size cannot exceed ${this.maxSize}kb`);
        e.target.value = "";
        return;
      }
    }
    await this.getToken();
    this.uploadFile(file);
    e.target.value = "";
  }

  async uploadFile(file) {
    var type = file.type.split("/");
    var filename = this.getUuid(32, 16) + `.${type[type.length - 1]}`;
    var formData = new FormData();
    formData.append("Filename", filename);
    formData.append("key", this.ossOptions.dir + filename); //存储在oss的文件路径
    formData.append("OSSAccessKeyId", this.ossOptions.accessid); //accessKeyId
    formData.append("policy", this.ossOptions.policy); //policy
    formData.append("Signature", this.ossOptions.signature); //签名
    //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
    formData.append("file", file);
    formData.append("success_action_status", "200"); //成功后返回的操作码
    var url = this.ossOptions.host;
    try {
      this.loading = true;
      let res = await axios.post(url, formData, {
        onUploadProgress: progressEvent => {
          let complete =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
        }
      });
      var fileUrl =
        this.ossOptions.domain + "/" + this.ossOptions.dir + filename;

      this.fileList.push({ url: fileUrl, type: type });
      this.picUrlList.push(url);

      this.$emit("onsuccess", fileUrl, this.fileList);
      this.loading = false;
    } catch {
      this.$emit("onerror");
      this.loading = false;
    }
  }

  checkFileType() {
    let typeList = this.accept.split(",");
  }

  handleRemove(index) {
    this.fileList.splice(index, 1);
    this.$emit("onRemove", index, this.fileList);
  }

  //获取uuid
  getUuid(len, radix) {
    let chars =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
        ""
      );
    let uuid = [],
      i;
    radix = radix || chars.length;

    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      let r;

      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4";

      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join("");
  }
}
